import { render, staticRenderFns } from "./CreateAuthor.vue?vue&type=template&id=292c3ff2&"
import script from "./CreateAuthor.vue?vue&type=script&lang=js&"
export * from "./CreateAuthor.vue?vue&type=script&lang=js&"
import style0 from "./CreateAuthor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports